import { CASE_SELECTOR } from '@/features/meeting-stats/utils/constants';

export default function getUniquePresentedCases(
  casePresentationHistory: string[] | undefined | null
): string[] {
  if (!casePresentationHistory) return [];
  const uniqueCases = new Set(
    casePresentationHistory.filter((elem) => elem && elem !== CASE_SELECTOR)
  );
  return Array.from(uniqueCases);
}
